export default function AboutMe() {
    return (
        <section id="AboutMe" className="about--section">
            <div className="about--section--img">
                <img src="./img/about-me2.png" alt="About Me" />
            </div>
            <div className="hero--section--content--box about--section--box">
                <div className="hero--section--content">
                    <h1 className="skills--section--heading"> About Me</h1>
                    <p className="hero--section-description">As an aspiring web developer, I bring expertise in front-end technologies like React, HTML, and CSS, enabling me to create visually appealing and functional websites. With a solid foundation in backend development using Express.js and database integration, I'm equipped to architect robust and efficient web applications. Additionally, my understanding of UI/UX design principles and proficiency in Webflow development ensure I can deliver engaging digital experiences tailored to meet the needs of employers and users alike.</p>
                </div>
            </div>
        </section>
    )
}